<template>
    <Drawer class="md:hidden" :mobile-only="true" name="ListingDrawer" @close="$emit('close')">
        <h2 class="px-4 mb-8 text-3xl font-bold leading-tight tracking-tight text-blue-500">
            Filter Results
        </h2>

        <div
            v-for="(selectField, i) in selects"
            :key="i"
            class="w-full px-1 mb-3 text-blue-500 border-b border-grey-200"
        >
            <p class="relative ml-3 small text-grey-500">
                {{ capitalize(selectField) }}
                <span
                    v-if="activeFacets[selectField]"
                    class="relative z-10 px-2 ml-3 text-white bg-blue-500 rounded cursor-pointer small py-2px"
                    @click="$emit('clear-facet', selectField)"
                >
                    Clear
                </span>
            </p>

            <Select
                :value="activeFacets[selectField]"
                :options="scopedFacets[selectField]"
                class="w-full"
                :settings="{ label: 'label' }"
                @input="$emit('update-facet', [selectField, $event])"
            />
        </div>

        <div class="w-full px-1 mb-3 text-blue-500 border-b border-grey-200">
            <p class="ml-3 small text-grey-500">Sort</p>

            <Select
                :value="activeSort"
                :options="sortOptions"
                :settings="{ label: 'label' }"
                class="w-full"
                @input="$emit('update-sort', $event)"
            />
        </div>

        <div class="px-4">
            <button class="w-full btn mt-14" @click="$modal.hide('ListingDrawer')">Update</button>
        </div>
    </Drawer>
</template>

<script>
import capitalize from 'lodash/capitalize';
import Drawer from '@/vue/components/Drawer';
import Select from '@/../vue/_base/form/Select';

export default {
    components: {
        Drawer,
        Select
    },

    props: {
        selects: {
            type: Array,
            required: true
        },
        activeFacets: {
            type: Object,
            required: true
        },
        scopedFacets: {
            type: Object,
            required: true
        },
        activeSort: {
            type: String,
            default: null
        },
        sortOptions: {
            type: Array,
            required: true
        }
    },

    methods: {
        capitalize(text) {
            return capitalize(text);
        }
    }
};
</script>
<style scoped>
.multiselect {
    @apply bg-white !important;
}
</style>
